import React, { Component } from 'react';
import './agile.css';

class AgileComponent extends Component {
	render() {
		return (
			<div className='agile'>
				<p className='headline'>
					<p className='text-justify'>
						I am a developer, so I know how to create your website to run across
						devices using the latest technologies available.
					</p>
				</p>
			</div>
		);
	}
}

export default AgileComponent;
